    import { useEffect } from 'react';
    import { useLocation } from 'react-router-dom';
    import ReactGA from 'react-ga4';

    const GAListener = () => {
      const location = useLocation();

      useEffect(() => {
        // Send page view on location change
        // ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
         ReactGA.send({ hitType: "pageview", page: location.pathname});
      }, [location]); // Re-run effect when location changes

      return null; // This component doesn't render anything
    };

    export default GAListener;